<!-- ApplicationListComponent.vue -->

<template>
  <div>
    <div>
      <div class="search-bar">
        <!-- <img src="@/assets/img/job-seeker/jam_search.svg" class="search-icon" height="20" alt="Search" /> -->
        <el-input
          v-model="filter.text"
          class="job-board__search"
          placeholder="Enter Job Title"
          clearable
          @input="debouncedUpdateLocalStorage"
          @clear="clearText"
        >
          <template #prefix>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                stroke="#484848"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M22 22L20 20"
                stroke="#484848"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </template>
        </el-input>
        <button
          class="filter-button"
          data-testid="directions-30"
          @click="toggleFilterOptions"
        >
          <!-- <img v-if="isFilterOptionsVisible" src="@/assets/img/job-seeker/setting-active.svg" /> -->
          <img src="@/assets/img/job-seeker/setting-inactive.svg" />
          <span v-if="countFilters() > 0">{{ countFilters() }}</span>
        </button>
      </div>
      <div class="search-bar">
        <el-select
          v-model="selectedJobId"
          :empty-values="[null, undefined]"
          :value-on-clear="null"
          clearable
          placeholder="Select job applied"
          @change="handleSelection"
          @clear="handleClear"
          class="select-job"
        >
          <el-option
            v-for="application in applicationJobList"
            :key="application.id"
            :label="application.title"
            :value="application.id"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div v-if="initialIsLoading">
      <job-listing-skeleton :skeletonCount="7" />
    </div>
    <div v-else>
      <template v-if="applications.length > 0">
        <ApplicationCard
          :applications="applications"
          @refresh-applicants-list="refreshApplicants"
        />

        <div v-if="isLoading" class="loading-animation">
          <ion-spinner name="dots"></ion-spinner>
        </div>
      </template>
      <template v-else>
        <div class="search_jobs_header no-results-job-listing">
          <img
            :src="require(`@/assets/img/illustrations/no-result.svg`)"
            alt=""
          />
          <div class="main_title">No Applicants!</div>
          <div class="main_text">No Applicants were found!</div>
        </div>
        <p class="no-results"></p>
      </template>
    </div>
    <div id="bottomApplicationsObserver"></div>
    <!-- <template v-else>
      <p>No applications available.</p>
    </template> -->

    <el-drawer
      title="Applicant Filters"
      v-model="modalJobApplicationVisible"
      :close-on-click-modal="true"
      :destroy-on-close="true"
      @close="closeCreateWishlistModal"
      :append-to-body="true"
      :direction="'btt'"
    >
      <Filter
        :modalJobApplicationVisible="modalJobApplicationVisible"
        @job-poster-application-filter="updateJobsWithFilters"
        @update:modalJobApplicationVisible="updateModalVisibility"
      />
    </el-drawer>
  </div>
</template>

<script>
import { useStore } from "vuex";
// import {
//   useRouter,
// } from "vue-router";
import {
  onMounted,
  ref,
  inject,
  watchEffect,
  watch,
  onBeforeMount,
  provide,
} from "vue";
import ApplicationCard from "./Cards/ApplicationCard.vue";
import { IonSpinner } from "@ionic/vue";
import JobListingSkeleton from "@/components/JobListingSkeleton/JobListingSkeleton.vue";
import Filter from "./Filters/ApplicantsFilterPage.vue";
import debounce from "lodash/debounce";
export default {
  components: {
    ApplicationCard,
    IonSpinner,
    JobListingSkeleton,
    Filter,
  },
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const $store = useStore();
    // const $router = useRouter();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const tabApplicationClicked = ref(false);
    const initialIsLoading = ref(false);
    const applicantStatusCategories = ref([]);
    const applications = ref([]);
    const selectedJobId = ref(null);
    const applicationJobList = ref([]);
    const modalJobApplicationVisible = ref(false);

    provide("applicantCategories", applicantStatusCategories);

    const currentPage = ref(1); // Track the current page
    const isLoading = ref(false); // Track if data is currently being loaded
    const filter = ref(
      JSON.parse(localStorage.getItem("jobPosterApplicantsFilterObject"))
        ? JSON.parse(localStorage.getItem("jobPosterApplicantsFilterObject"))
        : {
            text: "",
            type: "",
          }
    );

    const toggleFilterOptions = () => {
      modalJobApplicationVisible.value = true;
      // $router.push({
      //   name: "job_poster_applicants_filter",// Assuming job object has an 'id' property
      // });
    };

    const updateModalVisibility = (value) => {
      modalJobApplicationVisible.value = value;
    };

    const updateJobsWithFilters = () => {
      filter.value = JSON.parse(
        localStorage.getItem("jobPosterApplicantsFilterObject")
      )
        ? JSON.parse(localStorage.getItem("jobPosterApplicantsFilterObject"))
        : {
            text: "",
            type: "",
          };
      // countFilters();
      loadMoreJobs();
    };

    const refreshApplicants = () => {
      console.log("🚀 ~ refreshJobs ~ refreshJobs");
      initialFetchJobData();
    };
    watchEffect(() => {
      if (props.isActive && tabApplicationClicked.value === false) {
        // Run your initial fetch job data function
        initialFetchJobData();

        // Update tabApplicationClicked to true so that watchEffect doesn't run again
        tabApplicationClicked.value = true;
      }
    });

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadMoreJobs();
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: "500px 0px", // Adjust rootMargin for early loading
      threshold: 0.1, // Trigger when 10% of the element is visible
    });

    // Reset tabApplicationClicked when isActive changes to false
    watchEffect(() => {
      if (!props.isActive) {
        tabApplicationClicked.value = false;
      }
    });

    const countFilters = () => {
      let count = 0;
      for (const key in filter.value) {
        const value = filter.value[key];
        if (
          value != null &&
          value !== "" &&
          !(Array.isArray(value) && value.length === 0)
        ) {
          if (typeof value === "object" && Object.keys(value).length === 0) {
            continue; // Skip empty objects
          }
          if (key === "rate" && value.type === "") {
            continue; // Skip empty rate object
          }
          count++;
        }
      }
      // Adjust count if text, jobType, and jobLocation are all empty
      if (filter.value.text === "" && filter.value.type === "") {
        count--;
      }
      return count;
    };

    const initialFetchJobData = async () => {
      return new Promise((resolve) => {
        initialIsLoading.value = true;
        if (selectedJobId.value) {
          filter.value.job_post_id = selectedJobId.value;
        } else {
          delete filter.value.job_post_id;
        }
        $store
          .dispatch("JOB_POSTER_APPLICANTS_LIST", {
            page: currentPage.value,
            filter: filter.value,
          })
          .then((response) => {
            let jobFetchResult = response.data;
            console.log("🚀 ~ .then ~ jobFhghjghetchResult:", jobFetchResult);
            const jobsData = jobFetchResult.map((job) => ({
              applicantName: job?.applicant?.name,
              image: job?.applicant?.image,
              role: job?.applicant?.seekerRole,
              address: job?.applicant?.address,
              experience: job?.applicant?.experience,
              hourlyRate: job?.applicant?.salaryExpectationHourly,
              annuallyRate: job?.applicant?.salaryExpectationAnnually,
              cv: job.cv,
              skills: job?.applicant?.skills,
              aboutMe: job?.applicant?.aboutMe,
              result: true,
              title: job.jobPost.title,
              poster: job.jobPost.pharmacy.name,
              shortDescription: job.jobPost.shortDescription,
              type: job.jobPost.type,
              applied: job.appliedAgo,
              id: job.id,
              jobPostId: job.jobPost.id,
              application_tag_status: job.applicationTagStatus,
              description: job.jobPost.description,
              questions: job.questions,
              payInterval: job.jobPost.payInterval,
              federalPharmacistSupport:job.jobPost.federalPharmacistSupport,
            }));
            console.log("data are", jobsData);
            // Assign the mapped data to the jobs ref variable
            applications.value = jobsData;
            applications.value.meta = response.meta;
            applicationJobList.value = response.jobs;
            initialIsLoading.value = false;
            console.log(
              "🚀 ~ .then ~  applicationstttttttt.value:",
              applications.value
            );
            resolve(response);
          });
      });
    };
    const loadMoreJobs = async () => {
      // Prevent loading more data if already loading or if reached last page
      console.log("🚀 ~ loadMoreJobs ~ isLoading:", applications.value);
      if (
        isLoading.value ||
        currentPage.value >= applications.value.meta?.lastPage
      )
        return;
      console.log("🚀 ~ loadMoreJobs ~ currentPage:", currentPage);
      isLoading.value = true;
      try {
        if (selectedJobId.value) {
          filter.value.job_post_id = selectedJobId.value;
        } else {
          delete filter.value.job_post_id;
        }
        const response = await $store.dispatch("JOB_POSTER_APPLICANTS_LIST", {
          page: currentPage.value + 1,
          filter: filter.value,
        });
        console.log("🚀 ~ loadMoreJobs ~ response:", response)
        const newJobs = response.data.map((job) => ({
          applicantName: job?.applicant?.name,
          image: job?.applicant?.image,
          role: job?.applicant?.seekerRole,
          address: job?.applicant?.address,
          experience: job?.applicant?.experience,
          hourlyRate: job?.applicant?.salaryExpectationHourly,
          annuallyRate: job?.applicant?.salaryExpectationAnnually,
          cv: {
            link: true,
          },
          skills: job?.applicant?.skills,
          aboutMe: job?.applicant?.aboutMe,
          result: true,
          title: job.jobPost.title,
          poster: job.jobPost.pharmacy.name,
          shortDescription: job.jobPost.shortDescription,
          type: job.jobPost.type,
          applied: job.appliedAgo,
          jobPostId: job.jobPost.id,
          application_tag_status: job.applicationTagStatus,
          description: job.jobPost.description,
          questions: job.questions,
          federalPharmacistSupport:job.jobPost.federalPharmacistSupport ? job.jobPost.federalPharmacistSupport : null,
        }));
        applications.value = [...applications.value, ...newJobs];
        applications.value.meta = response.meta;
        currentPage.value++;
      } catch (error) {
        console.error("Error loading more jobs:", error);
      } finally {
        isLoading.value = false;
      }
    };

    // Function to update localStorage
    const updateLocalStorage = () => {
      console.log(
        "🚀 ~ updateLocalStorage ~ selectedValues.value",
        filter.value
      );
      localStorage.setItem(
        "jobPosterApplicantsFilterObject",
        JSON.stringify(filter.value)
      );
      currentPage.value = 1;
      initialFetchJobData();
    };
    const debouncedUpdateLocalStorage = debounce(updateLocalStorage, 500); // Adjust the debounce delay as needed
    // Watch for changes in filter and update localStorage accordingly
    watch(filter, () => {
      updateLocalStorage();
    });

    const clearText = () => {
      console.log("clear text");
      filter.value.text = "";
      currentPage.value = 1;
      debouncedUpdateLocalStorage();
      // Update local storage to remove only the 'text' property from 'jobPosterApplicantsFilterObject'
      const storedValues = JSON.parse(
        localStorage.getItem("jobPosterApplicantsFilterObject")
      );
      console.log("🚀 ~ clearText ~ storedValues:", storedValues);
      if (storedValues) {
        delete storedValues.text;
        localStorage.setItem(
          "jobPosterApplicantsFilterObject",
          JSON.stringify(storedValues)
        );
      }
      initialFetchJobData();
    };

    onBeforeMount(async () => {
      console.log("helellelelelelelle");
      try {
        const applicantStatusCategoriesResponse = await $store.dispatch(
          "GET_JOB_APPLICANT_STATUS_CATEGORIES"
        );
        applicantStatusCategories.value =
          applicantStatusCategoriesResponse.data;
        console.log(
          "🚀 ~ onBeforeMount ~ applicantStatusCategories:",
          applicantStatusCategories
        );
      } catch (error) {
        console.error("Error occurred:", error);
      }
    });

    onMounted(() => {
      setPageClassGlobal("global_job_poster_application_page");
      observer.observe(document.getElementById("bottomApplicationsObserver"));
    });

    const handleClear = () => {
      console.log("claredddddd");
      selectedJobId.value = null;
    };
    const handleSelection = (value) => {
      console.log("Selected Application:", value);
      updateLocalStorage();
      // Handle the selected application as needed
    };

    return {
      applications,

      toggleFilterOptions,
      isLoading,
      filter,
      updateLocalStorage,
      clearText,
      applicantStatusCategories,
      countFilters,
      refreshApplicants,
      debouncedUpdateLocalStorage,
      initialIsLoading,
      applicationJobList,
      selectedJobId,
      handleClear,
      handleSelection,
      updateJobsWithFilters,
      modalJobApplicationVisible,
      updateModalVisibility,
    };
  },
};
</script>
